// extracted by mini-css-extract-plugin
export default {"title":"vH45C","subTitle":"cdzgp","titleContainer":"YbOwx","titleCenter":"RCBRs","titleLeft":"Cxntm","titleRight":"Apsdo","noSecondaryHeaderItem":"AVXQ7"};